/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Existing_HintInputs */

const cs_sreality_seller_existing_hint = /** @type {(inputs: Sreality_Seller_Existing_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte makléře, který už je pod importním účtem RK. Mobil z adminu sem musíte opsat ručně — listSeller ho neposílá. Nový uživatel se na něj propojí místo založení nového.`)
};

const en_sreality_seller_existing_hint = /** @type {(inputs: Sreality_Seller_Existing_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a seller already under the office RK. Copy their mobil from admin.sreality.cz into the GSM field — listSeller does not return phones. The user will be linked instead of creating a new seller.`)
};

/**
* | output |
* | --- |
* | "Pick a seller already under the office RK. Copy their mobil from admin.sreality.cz into the GSM field — listSeller does not return phones. The user will be l..." |
*
* @param {Sreality_Seller_Existing_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_existing_hint = /** @type {((inputs?: Sreality_Seller_Existing_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Existing_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_existing_hint(inputs)
	return cs_sreality_seller_existing_hint(inputs)
});